import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useGetAllPersonsQuery } from "@/services/api";
import { FormInput, FormTextArea } from "@/shared/Components";
import { currentPersonSelector } from "@/pages/ContactsPage/slice";
import { PersonRecord } from "@/common/PersonRecord";
import { FormButtonSelect } from "@/shared/Components/Form/FormButtonSelect";
import { useRuntimeImage } from "@/entities/runtime-image";
import { useAppSelector } from "@/services/store";
import { handleFullName } from "@/shared/utils";
import styles from "./styles.module.scss";

export const ModalContent: FC = () => {
  const currentPerson = useAppSelector(currentPersonSelector);
  const { t } = useTranslation();
  const { getRuntimeImageURL } = useRuntimeImage();
  const { data: persons, isLoading } = useGetAllPersonsQuery();

  return (
    <div className={styles.root}>
      <div className={styles.field}>
        <p className={styles["field-title"]}>{t("contactsPage.connectedWith")}</p>
        <FormButtonSelect
          name="personId"
          className={styles["person-select"]}
          loading={isLoading}
          placeholder={t("notePage.selectPerson")}
          showSearch
          filterOption={(input, option) =>
            ((option?.label as string) ?? "")
              .toLowerCase()
              .split(" ")
              .join("")
              .includes(input.toLowerCase().split(" ").join(""))
          }
          optionRender={(item) => {
            return (
              <PersonRecord
                avatar={getRuntimeImageURL({ fileId: item?.data.person?.avatarFile?.fileId ?? "" })}
                group={item?.data.group}
                name={handleFullName(item?.data.person.firstName, item?.data.person.lastName)}
                selected={false}
              />
            );
          }}
          options={persons?.persons
            .filter((item) => item.id !== currentPerson?.id)
            .map((item) => ({
              person: item,
              value: item.id,
              label: `${item?.firstName ?? ""} ${item?.lastName ?? ""}`,
            }))}
        />
      </div>
      <div className={styles.field}>
        <p className={styles["field-title"]}>{t("contactsPage.connectedAs")}</p>
        <FormInput name="connection" placeholder={t("contactsPage.generalInfo.type")} />
      </div>
      <div className={styles.field}>
        <p className={styles["field-title"]}>{t("contactsPage.additionalInfo")}</p>
        <FormTextArea
          name="additionalInfo"
          className={styles["additional-info-text-area"]}
          placeholder={t("common.inputText")}
        />
      </div>
    </div>
  );
};
